import api from './apiClient';

// ─── ETL FLOW CRUD ───────────────────────────────────────────

export const getEtlFlows = async (tenantId = null) => {
  const params = tenantId ? `?tenantId=${tenantId}` : '';
  const response = await api.get(`/Etl/flows${params}`);
  return response.data;
};

export const getEtlFlow = async (id) => {
  const response = await api.get(`/Etl/flows/${id}`);
  return response.data;
};

export const createEtlFlow = async (tenantId, name, flowDefinition) => {
  const response = await api.post('/Etl/flows', {
    tenantId,
    name,
    flowDefinition: JSON.stringify(flowDefinition),
  });
  return response.data;
};

export const updateEtlFlow = async (id, tenantId, name, flowDefinition) => {
  const response = await api.put(`/Etl/flows/${id}`, {
    tenantId,
    name,
    flowDefinition: JSON.stringify(flowDefinition),
  });
  return response.data;
};

export const deleteEtlFlow = async (id) => {
  const response = await api.delete(`/Etl/flows/${id}`);
  return response.data;
};

// ─── ÇALIŞTIRMA GEÇMİŞİ ──────────────────────────────────────

export const getEtlRunHistory = async (flowId) => {
  const response = await api.get(`/Etl/flows/${flowId}/runs`);
  return response.data;
};

// ─── ÇALIŞTIRMA (dosya yükleme) ──────────────────────────────

export const runEtlFlow = async (flowId, files) => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  const response = await api.post(`/Etl/flows/${flowId}/run`, formData);
  return response.data;
};

// ─── ÇALIŞTIRMA (SSE stream) ─────────────────────────────────
//
// EventSource multipart POST desteklemediği için raw fetch kullanılır;
// stream ayrıştırma burada kapsüllenir (sayfa bileşeninde değil).
//
// nodeId verilirse akışın tamamı değil YALNIZCA o adım çalıştırılır
// (tasarım modunda tek adım deneme); bu çalıştırmalar geçmişe yazılmaz.
export const runEtlFlowSSE = async ({ flowId, files, onEvent, signal, nodeId = null }) => {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));

  const url = nodeId
    ? `/api/Etl/flows/${flowId}/nodes/${encodeURIComponent(nodeId)}/run`
    : `/api/Etl/flows/${flowId}/run`;

  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    body: formData,
    signal,
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`Sunucu hatası: ${response.status} ${text}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // SSE satırlarını ayır  ("data: {...}\n\n")
    const parts = buffer.split('\n\n');
    buffer = parts.pop() ?? ''; // son eksik parçayı tut

    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith('data:')) continue;
      try {
        onEvent(JSON.parse(line.slice(5).trim()));
      } catch { /* parse hatası — atla */ }
    }
  }
};